import { render, staticRenderFns } from "./viewParcel.vue?vue&type=template&id=0137b968&"
import script from "./viewParcel.vue?vue&type=script&lang=js&"
export * from "./viewParcel.vue?vue&type=script&lang=js&"
import style0 from "./viewParcel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports